import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Autocomplete from '@mui/material/Autocomplete';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { DealReasonForLoss } from '../../../../utils/enums';
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

export default function ClosedLostDialog({ open, onClose, amountPar, closingDatePar }) {
    const[amount, setAmount] = useState(0);
    const[closingDate, setClosingDate] = useState(dayjs());
    const[reasonForLoss, setReasonForLoss] = useState(0);

    useEffect(() => {
        setAmount(amountPar);
        setClosingDate(dayjs(closingDatePar));
    }, [amountPar, closingDatePar]);

    const handleConfirm = () => {
        const formValues = {
            amount,
            closingDate,
            reasonForLoss
        };
        onClose(true, formValues)
    };
    const handleCancel = () => onClose(false);

    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={handleCancel}
            >
                <DialogTitle>Verify Details</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: 300 }}>
                        {/* Amount Field */}
                        <TextField
                            label="Amount"
                            sx={{ mt: 2 }}
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            placeholder="Enter amount"
                            size="small"
                            fullWidth
                        />

                        {/* Closing Date Field */}
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Closing Date"
                                fullWidth
                                required
                                value={closingDate}
                                onChange={(newDate) => setClosingDate(newDate)}
                                slotProps={{
                                    textField: {
                                        variant: 'outlined',
                                        fullWidth: true,
                                        size: 'small'
                                    },
                                }}
                            />
                        </LocalizationProvider>

                        {/* Stage Field */}
                        <TextField
                            label="Stage"
                            value={"Closed Lost"}
                            size="small"
                            fullWidth
                            select
                            disabled // Non-editable dropdown
                            InputProps={{
                                style: { color: 'gray' }, // To emphasize the disabled state visually
                            }}
                        >
                            <MenuItem value="Closed Lost">Closed Lost</MenuItem>
                        </TextField>
                        <Autocomplete
                            disablePortal={false}
                            required
                            size="small"
                            options={DealReasonForLoss}
                            sx={{ width: "100%" }}
                            value={DealReasonForLoss.find((option) => option.value === reasonForLoss)}
                            onChange={(event, newValue) => setReasonForLoss(newValue ? newValue.value : '')}
                            renderInput={(params) => <TextField {...params} label="Reason For Loss" />}
                            PopperProps={{
                                modifiers: [
                                    {
                                        name: 'preventOverflow',
                                        enabled: true,
                                        options: {
                                            boundary: 'viewport',
                                        },
                                    },
                                ],
                            }}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancel}>Cancel</Button>
                    <Button onClick={handleConfirm} color="primary">Confirm</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}